<template>
  <resource-list-layout :resourceTitle="title">
    <template v-slot:filter>
      <upload-task-fitter :fitter="searchObj" @search="handleSearch" />
    </template>
    <template v-slot:operation>
      <el-button slot="append" type="primary" icon="el-icon-folder-opened" size="mini" @click="triggerFileInput">
        上传
        <input type="file" ref="taskFile" id="taskFile" webkitdirectory style="display: none" @change="handleFileChange" />
      </el-button>
<!--      <el-button slot="append" type="primary" size="mini" @click="startTasks">执行任务</el-button>-->
    </template>
    <resource-list-page-content :pageData="pageData" :cols="cols" v-loading="loading" />
  </resource-list-layout>
</template>

<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
import TaskFileInfoCounts from "./common/TaskFileInfoCounts"
import UploadTaskFitter from "./common/UploadTaskFitter"
export default {
  name: 'UploadTasks',
  components: {
    ResourceListLayout,
    ResourceListPageContent,
    TaskFileInfoCounts,
    UploadTaskFitter
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchObj) {
        str += "&" + key + "=" + this.searchObj[key]
      }
      return str
    }
  },
  watch: {
    pageOption: {
      handler (newVal) {
        this.fetchData()
      },
      deep: true
    }
  },
  data () {
    return {
      title: '上传任务',
      searchObj: {
        task_status: '',
        task_type: '',
        file_type: ''
      },
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30, // 每页显示条数
      },
      loading: false,
      cols: [
        { label: '任务编号', prop: 'task_code' },
        { label: '任务类型', prop: 'task_type' },
        { label: '数据维度', prop: 'file_type' },
        { label: '文件名', prop: 'file_name' },
        { label: '状态', prop: 'task_status' },
        { label: '重复编号', prop: 'repeat_code' },
        { label: '文件路径', prop: 'file_path', isNowrap: true },
        { label: '文件大小', prop: 'file_size' },
        { label: '文件信息数', prop: 'file_info_counts', component: TaskFileInfoCounts },
        { label: '入库信息数', prop: 'store_counts', component: TaskFileInfoCounts },
        { label: '操作人', prop: 'operator' },
        { label: '上传时间', prop: 'created_at' },
      ],
      file: null
    }
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios.get('/api/admin/upload_tasks?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.pageData = data.data.data
            this.pageOption.total = data.data.total
            this.loading = false
          }
        })
    },
    triggerFileInput () {
      this.$refs.taskFile.click()
    },
    handleFileChange (event) {
      const files = event.target.files
      if (!files) return this.$message.error('文件选择错误')
      let formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        formData.append('files[]', files[i]);
      }

      this.$axios.post('/api/admin/upload_tasks/upload', formData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.fetchData()
          }
        })
    },
    handleSearch (search) {
      this.resetCurrentPage()
    },
    resetCurrentPage () {
      if (this.pageOption.currentPage === 1) {
        this.fetchData()
        return
      }
      this.pageOption.currentPage = 1
    },
    startTasks () {
      this.$axios.post('/api/admin/upload_tasks/start_tasks', {}, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          }
        })
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/upload_tasks/UploadTasks.vue